import { MakeCall } from 'ha/services/apiV2/createMakeCall';

import { RequestUserDocumentViewUrl } from './types/UserDocument';

export default (makeCall: MakeCall) =>
  (userId: 'me' | number, docUUID: string) =>
    makeCall<RequestUserDocumentViewUrl>(
      'GET',
      `/api/v2/user/${userId}/document/${docUUID}/url`,
    );
